export default __webpack_public_path__ + "static/media/trr-food-smallplate-parfait.66375b73.png";